export interface VADisabilityExemption {
  state: string;
  ratingTiers: {
    minRating: number;
    maxRating: number;
    exemptionAmount?: number;
    exemptionPercentage?: number;
    description: string;
  }[];
  specialProvisions: {
    age65Plus?: {
      additionalExemption: number;
      description: string;
    };
    fullExemption?: {
      ratingRequired: number;
      description: string;
    };
  };
}

export const stateVAExemptions: Record<string, VADisabilityExemption> = {
  TX: {
    state: 'Texas',
    ratingTiers: [
      { minRating: 10, maxRating: 29, exemptionAmount: 5000, description: '$5,000 exemption' },
      { minRating: 30, maxRating: 49, exemptionAmount: 7500, description: '$7,500 exemption' },
      { minRating: 50, maxRating: 69, exemptionAmount: 10000, description: '$10,000 exemption' },
      { minRating: 70, maxRating: 99, exemptionAmount: 12000, description: '$12,000 exemption' },
      { minRating: 100, maxRating: 100, exemptionPercentage: 100, description: 'Full property tax exemption' }
    ],
    specialProvisions: {
      age65Plus: {
        additionalExemption: 12000,
        description: 'Additional $12,000 exemption for veterans 65+ with 10%+ rating'
      },
      fullExemption: {
        ratingRequired: 100,
        description: 'Complete property tax exemption for 100% disabled veterans'
      }
    }
  },
  FL: {
    state: 'Florida',
    ratingTiers: [
      { minRating: 10, maxRating: 99, exemptionAmount: 5000, description: '$5,000 exemption for 10%+ rating' },
      { minRating: 100, maxRating: 100, exemptionPercentage: 100, description: 'Full property tax exemption for 100% disabled' }
    ],
    specialProvisions: {
      fullExemption: {
        ratingRequired: 100,
        description: 'Complete property tax exemption for 100% disabled veterans'
      }
    }
  },
  IL: {
    state: 'Illinois',
    ratingTiers: [
      { minRating: 30, maxRating: 49, exemptionAmount: 2500, description: '$2,500 assessed value deduction' },
      { minRating: 50, maxRating: 69, exemptionAmount: 5000, description: '$5,000 assessed value deduction' },
      { minRating: 70, maxRating: 100, exemptionPercentage: 100, description: 'Full property tax exemption (county-dependent)' }
    ],
    specialProvisions: {
      fullExemption: {
        ratingRequired: 70,
        description: 'Full exemption available for 70%+ disabled veterans in most counties'
      }
    }
  },
  GA: {
    state: 'Georgia',
    ratingTiers: [
      { minRating: 100, maxRating: 100, exemptionAmount: 109986, description: 'Up to $109,986 assessed value exemption for 100% disabled or unemployable' }
    ],
    specialProvisions: {
      fullExemption: {
        ratingRequired: 100,
        description: 'Exemption up to $109,986 for 100% disabled or unemployable veterans'
      }
    }
  },
  CA: {
    state: 'California',
    ratingTiers: [
      { minRating: 100, maxRating: 100, exemptionAmount: 161209, description: 'Up to $161,209 exemption for 100% disabled veterans' }
    ],
    specialProvisions: {
      fullExemption: {
        ratingRequired: 100,
        description: 'Basic exemption ($161,209) for 100% disabled veterans'
      }
    }
  },
  NY: {
    state: 'New York',
    ratingTiers: [
      { minRating: 10, maxRating: 100, exemptionPercentage: 15, description: '15% property tax exemption for service-connected disability' }
    ],
    specialProvisions: {}
  }
};
